import React from 'react';
import { Link } from 'react-router-dom';
import indiaMapImg from "../../assests/map.jpg";
import schoolChildrenImg from "../../assests/ind-child.jpg";
import childrensHomeImg from "../../assests/childrens_home.jpg";
import schoolImg from "../../assests/school.jpg";
import seminaryImg from "../../assests/seminary.png";
import churchPlantingImg from "../../assests/plant_church.jpg";
import farmDairyImg from "../../assests/farm_diary.jpg";
import johnsonFamilyImg from "../../assests/titus_family.jpg";
import jamesonPortraitImg from "../../assests/james_main.png";

function OurStory() {

  const missions = [
    { icon: "🎓", label: "Training Nationals as\nPastors and Evangelists", path: "/training-nationals" },
    { icon: "⛪", label: "Planting Churches in\nUnreached Areas", path: "/planting-churches" },
    { icon: "👧", label: "Educating Children as\nFuture Leaders", path: "/educating-children" },
    { icon: "➕", label: "Providing Humanitarian\nAid", path: "/providing-humanitarian-aid" },
  ];

  const campusItems = [
    { img: childrensHomeImg, label: "Children's Home" },
    { img: schoolImg, label: "School" },
    { img: seminaryImg, label: "Seminary" },
    { img: churchPlantingImg, label: "Church Planting" },
    { img: farmDairyImg, label: "Farm and Dairy" },
  ];

  return (
    <div style={{ fontFamily: "'Georgia','Times New Roman',serif", color: "#222", backgroundColor: "#fff" }}>
      <div style={{ maxWidth: "860px", margin: "0 auto", padding: "0 1.5rem 3rem" }}>

        {/* ── Back link ── */}
        <Link to="/" style={{ fontSize: "13px", color: "#c47a1e", margin: "1.5rem 0 0", display: "inline-block", textDecoration: "none", userSelect: "none" }}>
          ← Back to Home
        </Link>

        {/* ── "Our Story" heading ── */}
        <h1 style={{ fontFamily: "'Dancing Script','Brush Script MT',cursive", fontSize: "2.4rem", color: "#c47a1e", margin: "1.2rem 0 0.15rem", fontWeight: 700 }}>
          Our Story
        </h1>
        <div style={{ display: "flex", gap: "4px", marginBottom: "1.4rem" }}>
          {[...Array(9)].map((_, i) => (
            <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#c47a1e" }} />
          ))}
        </div>

        {/* ── YouTube video ── */}
        <div style={{ width: "100%", borderRadius: "4px", overflow: "hidden", marginBottom: "1.8rem", border: "1px solid #ddd" }}>
          <iframe
            style={{ width: "100%", height: "320px", border: "none", display: "block" }}
            src="https://www.youtube.com/embed/005WR1oz5a8"
            title="What is Christ For India?"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* ── Story text + India map ── */}
        <div style={{ display: "flex", gap: "1.8rem", alignItems: "flex-start", marginBottom: "2rem", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: "220px", fontSize: "13.5px", lineHeight: "1.78", color: "#333" }}>
            <p style={{ marginBottom: "0.9rem" }}>
              Christ For India is a nonprofit organization, supporting a ministry campus in{" "}
              <strong>Visakhapatnam</strong>, east of India, and led by{" "}
              <strong>Rev. Jameson P. Titus</strong>. His parents, Dr. P.J. and Mary Titus founded
              the ministry in 1981 when they sold their house in the United States and moved back to
              India in order to preach the Gospel to the unreached.
            </p>
            <p style={{ marginBottom: "0.9rem" }}>
              Christ For India began with one vision:{" "}
              <strong>Reaching One Billion Plus Souls For Christ.</strong>
            </p>
            <p style={{ marginBottom: "0.9rem" }}>
              Then, COTR College of Ministries and the New Testament Churches of India were founded.
              Due to his years of commitment, Dr. Titus became a theologian, missionary, evangelist
              and orator of worldwide renown.
            </p>
            <p style={{ marginBottom: 0 }}>
              In addition to spreading the Gospel, Dr. P.J. and Mary Titus were concerned about
              orphaned and poor children. Mary Titus began her home for orphans in 1994 with 50
              children and taught them under the mango trees. This led to the formation of Nava
              Jeevan Institution and Nava Jeevan Children's Home.
            </p>
          </div>
          <img src={indiaMapImg} alt="India Map"
            style={{
              width: "200px",
              height: "300px", flexShrink: 0, borderRadius: "4px", objectFit: "contain", marginTop: "4px"
            }} />
        </div>

        {/* ── Continuation text + school children ── */}
        <div style={{ display: "flex", gap: "1.8rem", alignItems: "flex-start", marginBottom: "2.5rem", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: "200px", fontSize: "13.5px", lineHeight: "1.78", color: "#333" }}>
            <p style={{ marginBottom: "0.9rem" }}>
              Dr. P.J. Titus passed away in 2003 and Mary continued the mission and vision as
              co-founder and president in India along with her two sons, Rev. Jameson and Rev. Johnson.
            </p>
            <p style={{ marginBottom: "0.9rem" }}>
              Mary Titus passed away in 2017. Rev. Johnson then gave leadership until he passed away
              in 2021. Their daughter Jyothi Titus supports the ministry.
            </p>
            <p style={{ marginBottom: 0 }}>
              Rev. Jameson P. Titus and Rev. Johnson's family continue to lead the ministry in India.
            </p>
          </div>
          <img src={schoolChildrenImg} alt="School Children"
            style={{ width: "300px", flexShrink: 0, borderRadius: "4px", objectFit: "cover" }} />
        </div>

        {/* ── The Titus Family banner ── */}
        <div style={{
          backgroundColor: "#f5f5f5", textAlign: "center", padding: "1rem",
          fontSize: "1.1rem", fontWeight: "600", color: "#222",
          margin: "0 0 2.5rem", borderTop: "1px solid #ddd", borderBottom: "1px solid #ddd",
        }}>
          The Titus Family
        </div>

        {/* ── Family tree ── */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "2rem",
          }}
        >
          <img
            src={johnsonFamilyImg}
            alt="The Titus Family"
            style={{
              width: "100%",
              maxWidth: "850px",
              height: "auto",
              borderRadius: "6px",
              border: "1px solid #ddd",
            }}
          />
        </div>

        {/* ── President quote ── */}
        <div style={{
          display: "flex", gap: "1.8rem", alignItems: "flex-start",
          padding: "1.8rem", backgroundColor: "#fafafa", marginBottom: "1rem", flexWrap: "wrap",
        }}>
          <img src={jamesonPortraitImg} alt="Rev. Jameson P. Titus"
            style={{ width: 90, height: 90, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: "3px solid #ddd" }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: "3.5rem", color: "#c47a1e", fontFamily: "Georgia,serif", lineHeight: 1, marginBottom: "0.5rem" }}>"</div>
            {[
              "I have been married since 1987 to my wife Deanna, and we have a son and two daughters. We are the proud grandparents of 6 grandchildren.",
              "I serve as President of Christ For India. I am the son of the late Dr. P.J. Titus and Mary Titus, co-founder and president of the ministry. Over the years, I have served many roles: office work, board director, and Vice President. In February 2002, I began working for Christ For India on a full time basis. I was unanimously elected President of this world-impacting ministry in 2003.",
              "Since my brother Johnson passed away, I have been representing Christ For India throughout the world (US, India, UK, Switzerland, Australia and Central America), speaking at mission conferences, churches, conventions, and in small groups. I report to all the partners worldwide and keep the communication lines open between them and the ministry campus. I also host and coordinate vision teams travelling to the campus in India.",
              "Thank you for your support and prayers!\nFor India and her people,",
            ].map((text, i) => (
              <p key={i} style={{ fontSize: "13.5px", lineHeight: "1.75", color: "#444", marginBottom: "0.75rem", whiteSpace: "pre-line" }}>
                {text}
              </p>
            ))}
            <p style={{ fontWeight: "700", fontSize: "13px", color: "#222", marginTop: "0.5rem" }}>
              Rev. Jameson P. Titus, President
            </p>
          </div>
        </div>

      </div>

      {/* ── Our Missions green band ── */}
      <div style={{ backgroundColor: "#2d6a2d", color: "#fff", padding: "2.8rem 1.5rem", textAlign: "center" }}>
        <p style={{ fontSize: "11px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.75, margin: "0 0 0.3rem" }}>
          What We Do
        </p>
        <h2 style={{ fontFamily: "'Dancing Script','Brush Script MT',cursive", fontSize: "2.6rem", fontWeight: 700, margin: "0 0 0.4rem" }}>
          Our Missions
        </h2>
        <p style={{ letterSpacing: "5px", opacity: 0.5, margin: "0 0 2rem", fontSize: "12px" }}>
          · · · · · · · · · · ·
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "2.5rem", flexWrap: "wrap" }}>
          {missions.map((m, i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "135px", gap: "0.5rem" }}>
              <span style={{ fontSize: "2.2rem" }}>{m.icon}</span>
              <p style={{ fontSize: "13px", lineHeight: "1.45", textAlign: "center", fontWeight: "600", margin: 0, whiteSpace: "pre-line" }}>
                {m.label}
              </p>
              <Link
                to={m.path}
                style={{
                  background: "transparent", border: "2px solid #fff", color: "#fff",
                  padding: "5px 16px", fontSize: "11px", fontWeight: "700",
                  cursor: "pointer", fontFamily: "inherit", marginTop: "4px", letterSpacing: "0.5px",
                  textDecoration: "none", display: "inline-block",
                }}>
                READ MORE
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* ── Our Ministry Campus section ── */}
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "3rem 1.5rem 3.5rem" }}>
        <h2 style={{ fontFamily: "'Dancing Script','Brush Script MT',cursive", fontSize: "2.4rem", color: "#c47a1e", margin: "0 0 0.15rem", fontWeight: 700 }}>
          Our Ministry Campus
        </h2>
        <div style={{ display: "flex", gap: "4px", marginBottom: "1.4rem" }}>
          {[...Array(9)].map((_, i) => (
            <div key={i} style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#c47a1e" }} />
          ))}
        </div>

        <p style={{ fontSize: "13.5px", lineHeight: "1.78", color: "#333", marginBottom: "2rem" }}>
          Over the years, the ministry campus expanded. Today, under the leadership of Rev. Jameson P.
          Titus, the campus houses:
        </p>

        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "1.5rem", flexWrap: "wrap" }}>
          {campusItems.map((item, i) => (
            <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "200px", height: "200px" }}>
              <img src={item.img} alt={item.label}
                style={{ width: "100%", height: "150px", objectFit: "cover", borderRadius: "4px" }} />
              <p style={{ fontSize: "14px", color: "#333", textAlign: "center", marginTop: "0.75rem" }}>
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OurStory;
